import { on } from '@ember/modifier';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';
import { AppEvent } from 'webapp/enums/events';

import BlockSettingsComponent from 'webapp/components/block/settings';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import ReportsEditorBlockCtBgColorComponent from 'webapp/components/reports/editor/block-ct-bg-color';

import type ReportSlideFragment from 'webapp/models-custom/report-slide-fragment';

interface Args {
	fragment?: ReportSlideFragment | null;
	onClose: () => void;
}

export default class ReportsEditorBlockSettingsComponent extends Component<Args> {
	@service('event-manager') declare eventManagerService: Service.EventManager;

	@tracked isAiSummaryBeingEdited = false;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.setupAiSummaryEditingStateChanges();
	}

	get block() {
		return this.args.fragment?.block;
	}

	// to pass to block settings component which expects non-nullable block
	// null check happens in showBlockSettings
	get nonNullBlock() {
		return this.block!;
	}

	get blockSetup() {
		return this.block?.blockSetup;
	}

	get visualization() {
		return this.blockSetup?.visualization;
	}

	get isAiSummary() {
		return this.block?.isAiSummary;
	}

	get showBlockSettings() {
		return !this.isAiSummaryBeingEdited && this.block;
	}

	override willDestroy() {
		super.willDestroy();
		this.eventManagerService.off(AppEvent.AI_SUMMARY_EDITING_STATE_CHANGED, this);
	}

	private setupAiSummaryEditingStateChanges() {
		this.eventManagerService.on(
			AppEvent.AI_SUMMARY_EDITING_STATE_CHANGED,
			this,
			(eventData) => {
				this.isAiSummaryBeingEdited = eventData.isEditing;
			},
		);
	}
	<template>
		{{#if this.showBlockSettings}}
			<div class="report_slide_block_settings">
				<div class="bs-panel designer-panel designer-panel--right">

					{{#if @fragment}}
						<div class="designer-panel__inner">

							<div class="designer-panel__title">
								Datablock editor
								<a role="button" class="close" {{on "click" @onClose}}>
									<CommonUiIconComponent @name="Close" />
								</a>
							</div>

							<div class="designer-panel__bg"></div>

							<div class="designer-panel__inner-content">
								<BlockSettingsComponent
									@model={{this.nonNullBlock}}
									@isPanelOpen={{true}}
								>
									<:additionalSettings>
										{{#unless this.block.isFromReportStoryText}}
											<ReportsEditorBlockCtBgColorComponent
												@model={{@fragment}}
											/>
										{{/unless}}
									</:additionalSettings>
								</BlockSettingsComponent>
							</div>
						</div>
					{{/if}}
				</div>
			</div>
		{{/if}}
	</template>
}
